import type { OrganizationSchema } from '../types/organization.type';

export function getOrganizationLogoUrl(org: OrganizationSchema | null | undefined): string | null {
  if (!org) return null;
  if (typeof org.logo_url === 'string' && org.logo_url) return org.logo_url;
  const data = org.data as Record<string, unknown> | undefined;
  if (typeof data?.logo_url === 'string' && data.logo_url) return data.logo_url;
  if (typeof data?.logo === 'string' && data.logo) return data.logo;
  return null;
}
